{
  "accessPage": {
    "list": {
      "title": "Список правил",
      "empty": "Список правил пуст",
      "newElement": "Новое правило"
    },
    "item": {
      "empty": "Выберите правило или создайте новое"
    }
  },
  "ruleItem": {
    "title": "Правило",
    "label": "Отображение",
    "name": "Название",
    "action": "Действие",
    "accessRight": "Доступ",
    "active": "Активно",
    "expand": "Расширяемое",
    "expandTooltip": "При добавление нового элемента, правило будет дополнено",
    "tab": {
      "cit": "ТКЕ",
      "healthIndicators": "Индикаторы здоровья",
      "user": {
        "label": "Пользователь",
        "anyUser": "Любой пользователь",
        "noUser": "Нет пользователя",
        "login": "Логин"
      },
      "dashboards": "Дашборды",
      "navigation": "Функции"
    },
    "addTQL": "Добавление TQL"
  },
  "table": {
    "name": "Имя",
    "read": "Просмотр",
    "edit": "Изменение"
  },
  "ruleCitDialog": {
    "title": "Фильтр"
  },
  "actionFilterDialog": {
    "title": "Фильтр действия"
  }
}